import cx from 'classnames'
import PropTypes from 'prop-types'

import {BASE_CLASS} from '../../config.js'

const PanelPriceIndicatorRank = ({color, isHighlighted, label}) => {
  const baseClassNames = cx(
    `${BASE_CLASS}-rank`,
    `${BASE_CLASS}-rank--${color}`,
    isHighlighted && `${BASE_CLASS}-rank--highlighted`
  )

  const rankBarClassNames = cx(`${BASE_CLASS}-rankBar`, `${BASE_CLASS}-rankBar--${color}Color`)

  return (
    <div className={baseClassNames}>
      <span className={rankBarClassNames} />
      <p className={`${BASE_CLASS}-rankLabel`}>{label}</p>
    </div>
  )
}

PanelPriceIndicatorRank.displayName = 'PanelPriceIndicatorRank'

PanelPriceIndicatorRank.propTypes = {
  color: PropTypes.string,
  isHighlighted: PropTypes.bool,
  label: PropTypes.string
}

export default PanelPriceIndicatorRank
